export default {
    methods: {
        mixin_autoResize_resize(event) {
            event.target.style.height = "1em";
            event.target.style.height = `${event.target.scrollHeight}px`;
        }
    },
    mounted() {
        this.$nextTick(() => {
            try {
                this.$el 
                && this.$el.setAttribute
                && this.$el.setAttribute("style", "height",`${this.$el.scrollHeight}px`);
            } catch (error) {
                this.$rollbar.error(error);
            }
            
        });
    }
};